import { RELATIVE_DATE_LIST } from './relativeDatesList';

export const getRelativeDateList = (_field: AutomationActionField) => {
  if (_field.fieldType === 'Date') {
    return RELATIVE_DATE_LIST.Date;
  }
  return RELATIVE_DATE_LIST.DateTime;
};
